<div class="deviceAutoLoginSetupWrapper h-100">
	<mat-stepper #stepper [linear]="true" color="accent">
		<ng-template matStepperIcon="edit">
			<mat-icon fontIcon="fa-check" fontSet="far" inline="true" />
		</ng-template>

		<!-- Step 1: Room Selection -->
		<mat-step [completed]="setupAutoLoginForm.controls.roomSelection.valid" [stepControl]="setupAutoLoginForm.controls.roomSelection">
			<ng-template matStepLabel>{{ T.REGISTER_DEVICE_ASSIGN_DEVICE_TO_ROOM | translate }}</ng-template>

			<ng-container *ngTemplateOutlet="selectRoomTemplate" />
		</mat-step>

		<!-- Step 2: Assign Device Type -->
		<mat-step [stepControl]="setupAutoLoginForm.controls.deviceType">
			<ng-template matStepLabel>{{ T.REGISTER_DEVICE_ASSIGN_TYPE_TO_DEVICE | translate }}</ng-template>

			<div class="assignDeviceAutoLoginTypeStepWrapper h-100">
				<ng-container *ngTemplateOutlet="currentlySelectedRoom" />

				<ng-container *ngTemplateOutlet="selectDeviceType" />
			</div>
		</mat-step>

		<!-- Step 3: Finish Setup -->
		<mat-step>
			<ng-template matStepLabel>{{ T.REGISTER_DEVICE_FINISH_SETUP | translate }}</ng-template>

			<div class="assignDeviceAutoLoginTypeStepWrapper h-100">
				<ng-container *ngTemplateOutlet="currentlySelectedRoom" />

				<ng-container *ngTemplateOutlet="selectDeviceType" />

				<ng-container *ngTemplateOutlet="step3summary" />
			</div>
		</mat-step>
	</mat-stepper>
</div>

<ng-template #selectRoomTemplate>
	<sim-training-room-navigation-panel
		(onTrainingRoomClicked)="selectRoom($event)"
		[allowSelectionWhenOccupied]="true"
		[planViewReadOnly]="true"
		[planView]="isRoomSelectionPlanViewEnabled"
		[trainingRoomWhitelist]="null"
		class="h-100"
	>
		<span planViewToggle>
			<sim-segmented-button>
				<sim-button-segment
					(onClick)="toggleRoomSelectionPlanView(false)"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-list-ul'}"
					[matTooltip]="T.SIM_ROOM_PLANNER_LIST_VIEW | translate"
					matTooltipClass="accent"
				/>
				<sim-button-segment
					(onClick)="toggleRoomSelectionPlanView(true)"
					[icon]="{fontSet: 'fad', fontIcon: 'fa-bring-front'}"
					[matTooltip]="T.SIM_ROOM_PLANNER_PLAN_VIEW | translate"
					matTooltipClass="accent"
				/>
			</sim-segmented-button>
		</span>
	</sim-training-room-navigation-panel>
</ng-template>

<ng-template #currentlySelectedRoom>
	<div class="currentlySelectedRoom">
		<div class="assignedRoomTitle">{{ T.REGISTER_DEVICE_SELECTED_ROOM_LABEL | translate }}</div>

		@if (setupAutoLoginForm.controls.roomSelection.valid) {
			<sim-training-room-button
				[isButtonView]="false"
				[isChecked]="true"
				[trainingRoom]="setupAutoLoginForm.controls.roomSelection.value"
			/>
		}

		<button (click)="stepper.selectedIndex = 0" color="accent" mat-button>
			{{ T.REGISTER_DEVICE_SELECTED_ROOM_CHANGE | translate }}
		</button>
	</div>

	<mat-divider [vertical]="true" class="prevStepDivider" />
</ng-template>

<ng-template #selectDeviceType>
	<div class="assignDeviceType">
		<div class="assignDeviceTypeTitle">{{ T.REGISTER_DEVICE_SELECT_TYPE_TITLE | translate }}</div>
		<div class="deviceTypeSelection">
			@for (deviceType of selectableDeviceTypes(); track deviceType.type) {
				<div class="deviceTypeWrapper">
					<div
						(click)="setDeviceType(deviceType)"
						[class.active]="setupAutoLoginForm.controls.deviceType?.value === deviceType.type"
						class="deviceType"
						mat-ripple
					>
						<i class="fa-3x {{ deviceType.icon.fontSet }} {{ deviceType.icon.fontIcon }}"></i>
					</div>
					<div class="deviceTypeDescription">
						{{ deviceType.translationKey | translate }}
					</div>
				</div>
			}
		</div>
	</div>
	@if (stepper.selectedIndex === 2) {
		<mat-divider [vertical]="true" class="prevStepDivider" />
	}
</ng-template>

<ng-template #step3summary>
	<div class="summary">
		<div class="summaryTitle">{{ T.REGISTER_DEVICE_FINISH_SETUP_STEP | translate }}</div>
		<sim-button
			(onClick)="finishSetup()"
			[icon]="{
				fontSet: 'fad',
				fontIcon: 'fa-check-double',
			}"
			[label]="T.REGISTER_DEVICE_FINISH_SETUP_STEP"
			class="finishSetupBtn"
		/>
		<p class="secondary">
			{{ T.REGISTER_DEVICE_FINISH_SETUP_STEP_SUMMARY_TEXT | translate }}
		</p>
	</div>
</ng-template>
